import clsx from 'clsx';
import { memo } from 'react';

import type { MetricStatus } from '../domain';
import styles from './metric-card.module.scss';

type MetricCardProps = {
  title: string;
  value: string;
  status: MetricStatus;
  description: string;
};

const MetricCard = memo(
  ({ title, value, status, description }: MetricCardProps) => (
    <div className={clsx(styles.card, styles[`card-${status}`])}>
      <div className={styles.cardHeader}>
        <h3 className={styles.cardTitle}>{title}</h3>
        <div
          className={clsx(styles.statusIndicator, styles[`status-${status}`])}
        />
      </div>
      <div className={styles.cardValue}>{value}</div>
      <div className={styles.cardDescription}>{description}</div>
    </div>
  )
);

MetricCard.displayName = 'MetricCard';

export { MetricCard };
